import { PendoProps } from "@impero-com/ui";
import { Select } from "antd";
import { DefaultOptionType } from "rc-select/es/Select";

interface MultipleOptionFilterSelectProps extends PendoProps {
    options: Array<{
        label: string;
        value: string | number;
        customLabel?: React.ReactNode;
    }>;
    placeholder: string;
    value: Array<string | number> | undefined;
    onChange: (value: Array<string | number>) => void;
    dropdownMatchSelectWidth?: number | boolean | undefined;
    /** options are already in the correct order */
    presorted?: boolean;
    /** Widen the select, e.g. for the roomier dashboard filter panels. */
    minWidth?: number;
}

const collator = new Intl.Collator();
export function MultipleOptionFilterSelect({
    options,
    placeholder,
    value,
    onChange,
    dropdownMatchSelectWidth = false,
    presorted = false,
    minWidth = 200,
    "data-pendo": dataPendo,
}: MultipleOptionFilterSelectProps) {
    const sortedOptions = !presorted
        ? options.sort((a, b) => collator.compare(a.label, b.label))
        : options;
    const getFilterOption = (
        input: string,
        option: DefaultOptionType | undefined
    ) => {
        const label = option?.label;
        return typeof label === "string"
            ? label.toLowerCase().includes(input.toLowerCase())
            : false;
    };
    return (
        <Select
            mode="multiple"
            autoFocus
            // antd forwards unknown `data-*` props to the select's root element.
            data-pendo={dataPendo}
            placeholder={placeholder}
            dropdownMatchSelectWidth={dropdownMatchSelectWidth}
            style={{ minWidth }}
            value={value}
            onChange={onChange}
            // Search against the label, not the option value. The value can be
            // an id (e.g. control program id) that doesn't match what's typed.
            optionFilterProp="label"
            filterOption={getFilterOption}
        >
            {sortedOptions.map((option) => (
                <Select.Option
                    key={option.value}
                    value={option.value}
                    label={option.label}
                >
                    {option.customLabel ?? option.label}
                </Select.Option>
            ))}
        </Select>
    );
}
